module.exports = __webpack_public_path__ + "jtails-build/img/person.ba802632.svg";